import styled from 'styled-components';

export const TitleListWrap = styled.span`
    font-size: 0.81rem;
    line-height: 120%;
    font-weight: 900;
    color: ${(props) => props.theme.colors.textSenary};
    text-transform: uppercase;
`;
